// eslint-disable-next-line no-unused-vars
import Headroom from "headroom.js";
// eslint-disable-next-line no-unused-vars
import lity from "lity";
// eslint-disable-next-line no-unused-vars
import Sticky from "sticky-kit/dist/sticky-kit.js";
// eslint-disable-next-line no-unused-vars
import ProgressBar from "progressbar.js/dist/progressbar.js";
// eslint-disable-next-line no-unused-vars
import { CountUp } from 'countup.js';
// eslint-disable-next-line no-unused-vars
import { gsap } from "gsap/dist/gsap";
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
// eslint-disable-next-line no-unused-vars
//gsap.registerPlugin(ScrollTrigger);


export default {
  init() {
    /* eslint-disable no-unused-vars */

    // gsap.to("#cerc-cover", {
    //   scaleX: 200, scaleY: 200,
    //   opacity: 0,
    //   "clip-path": "circle(88% at 50% 100%)",
    //   scrollTrigger: {
    //     trigger: ".image-section-wrap",
    //     start: "50% center",
    //     end: '200%',
    //     scrub: true,
    //     pin: false,
    //     markers: true,
    //   },
    // });

    // gsap.to("#cerc-cover", {
    //   "clip-path": "circle(150% at 50% 120%)",
    //   scrollTrigger: {
    //     trigger: ".image-section-wrap",
    //     start: "top-=500px top",
    //     end: '100%',
    //     scrub: true,
    //     pin: false,
    //     markers: true,
    //   },
    // });

    $(document).on('click', 'a[href="#crw-multi-step-form"]', function(e){
      e.preventDefault();
      if ( $('#crw-multi-step-form').length > 0 ) {
        $('#crw-multi-step-form').closest('.crw-multistep-form-wrap').removeClass('animate-form');
        $('#crw-multi-step-form').closest('.crw-multistep-form-wrap').removeClass('animate-cta');

        $('body,html').animate({
          scrollTop: $('#crw-multi-step-form').offset().top - 100,
        }, 300);
        setTimeout(function(){
          $('#crw-multi-step-form').closest('.crw-multistep-form-wrap').addClass('animate-form');
        }, 600);

        setTimeout(function(){
          $('#crw-multi-step-form').closest('.crw-multistep-form-wrap').addClass('animate-cta');
        }, 900);

        setTimeout(function(){
          $('#crw-multi-step-form').closest('.crw-multistep-form-wrap').removeClass('animate-form');
          $('#crw-multi-step-form').closest('.crw-multistep-form-wrap').removeClass('animate-cta');
        }, 3000);
      }
    });

    // Dealing with Textarea Height
    function calcHeight(value) {
      let numberOfLineBreaks = (value.match(/\n/g) || []).length;
      // min-height + lines x line-height + padding + border
      let newHeight = 53 + numberOfLineBreaks * 26 + 12 + 1;
      return newHeight;
    }

    let textarea = document.querySelector(".resize-ta");

    if (textarea) {
      textarea.addEventListener("keyup", () => {
        textarea.style.height = calcHeight(textarea.value) + "px";
      });
    }


    if ( $('.crw-how-works').length > 0 ) {
      gsap.registerPlugin(ScrollTrigger);

      gsap.to("#first-h", {
        x: '100%',
        scrollTrigger: {
          trigger: ".crw-how-works",
          start: "top-=350px top",
          end: '80%',
          scrub: true,
          pin: false,
          markers: false,
        },
      });

      gsap.to("#second-h", {
        x: '-100%',
        scrollTrigger: {
          trigger: ".crw-how-works",
          start: "top-=350px top",
          end: '100%',
          scrub: true,
          pin: false,
          markers: false,
        },
      });

      gsap.to(".features-list-cnt", {
        y: '-24vh',
        scrollTrigger: {
          trigger: ".crw-how-works",
          start: "top-=600px top",
          end: '50%',
          scrub: true,
          pin: false,
          markers: false,
        },
      });
    }

    function imageHandler() {
      var tl = gsap.timeline();

      tl.to(".image-section-wrap", {
        y: -250,
        scrollTrigger: {
          trigger: ".image-section-wrap",
          start: "top-=650px top",
          end: 'top-=50px top',
          scrub: true,
          pin: false,
          //markers: true,
        },
      });

      tl.to("#left-masker-svg", {
        //clip-path": "circle(150% at 50% 120%)",
        x: 950,
        y: 0,
        //scale: 0.5,
        //rotate: -27,
        // height: 0,
        // width: '100%',
        scrollTrigger: {
          trigger: ".image-section-wrap",
          start: "top-=650px top",
          end: 'top-=100px top',
          scrub: true,
          pin: false,
          //markers: true,
        },
      });

      tl.to("#right-masker-svg", {
        //clip-path": "circle(150% at 50% 120%)",
        x: -950,
        y: 0,
        //scale: 0.5,
        //rotate: 27,
        // height: 0,
        // width: '100%',
        scrollTrigger: {
          trigger: ".image-section-wrap",
          start: "top-=650px top",
          end: 'top-=100px top',
          scrub: true,
          pin: false,
          //markers: true,
          //onLeave: middle,
        },
      });

      tl.to(".bg-overlay", {
        opacity: 0.6,
        scrollTrigger: {
          trigger: ".image-section-wrap",
          start: "top-=450px top",
          end: 'top-=100px top',
          scrub: true,
          pin: false,
          //markers: true,
        },
      });

      tl.to(".image-cnt", {
        opacity: 1,
        scrollTrigger: {
          trigger: ".image-section-wrap",
          start: "top-=450px top",
          end: 'top-=100px top',
          scrub: true,
          pin: false,
          //markers: true,
        },
      });
    }

    if ( $('.crw-how-works').length > 0 ) {
      let master = gsap.timeline();

      master
      .add(imageHandler());
    }


    if ($(".crw-spotlight")[0]){
      let hovered_flag = false;
      let circle = new ProgressBar.Circle('#progress-container', {
        color: '#fff',
        trailColor: '#ffffff6e',
        strokeWidth: 4,
        duration: 1800,
      });

      const divs=$(".crw-spotlight .spot-card");
      divs.i=0;


      setInterval(function(){
        if (hovered_flag) return
        circle.set(0.0);
        divs[divs.i++].classList.remove("active");

        divs[divs.i=divs.i%divs.length].classList.add("active")
        let listUrl = divs[divs.i=divs.i%divs.length].dataset.url;
        $('#spot_bg').css("background-image", "url('" + listUrl + "')");
        circle.animate(1);

      },2000);

      $(document).on({
          mouseenter: function () {
              let trigger = $(this);
              let listItem = this.dataset.url;

              $('.crw-spotlight .spot-card').removeClass('active');


              trigger.toggleClass('active');
              $('#spot_bg').css("background-image", "url('" + listItem + "')");
              hovered_flag = true;
              circle.set(0);
          },
          mouseleave: function () {
              hovered_flag = false;
              $('.crw-spotlight .spot-card').removeClass('active');
              circle.set(0);

          },

      }, ".crw-spotlight .spot-card");
    }


    $(function() {
      let footerHeight = $('#footer-fixed').outerHeight();
      $('#crw-footer').css("padding-bottom", footerHeight);
    });

    /*Start animated */

    function isScrolledIntoView($elem) {
      var returnvalue = false;
      if ( $elem.length > 0 ) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $elem.offset().top;
        returnvalue = ((elemTop <= docViewBottom - 20) && (elemTop >= docViewTop + 20));
      }
      return returnvalue;
    }


    function crw_animate_numbers($elem) {
      if (!$elem) {
        $('.animated-numbers-wrap').each(function () {
          if (isScrolledIntoView($(this))) {
            if (!$(this).hasClass('animated')) {
              $(this).addClass('animated');

              $(this).find('.large-nr').each(function () {
                var options = {
                  useEasing: false,
                  useGrouping: true,
                  separator: '',
                  decimal: '',
                  prefix: '',
                  suffix: '',
                };
                var suffix = $(this).attr('data-suffix'),
                  prefix = $(this).attr('data-prefix'),
                  number = $(this).attr('data-number'),
                  grouping = $(this).attr('data-grouping'),
                  separator = $(this).attr('data-separator'),
                  decimals = 0,
                  decimal = $(this).attr('data-decimal');
                if (number.indexOf('.') !== -1) {
                  decimals = 1;
                }
                if (grouping === "true") {
                  options.useGrouping = true;
                  options.decimal = decimal;
                  options.separator = separator;
                } else {
                  options.useGrouping = false;
                }
                if (prefix !== "false") {
                  options.prefix = prefix;
                }
                if (suffix !== "false") {
                  options.suffix = suffix;
                }
                var countup = new CountUp($(this)[0], number, decimals, options);
                countup.start();
              });

              var circclass1 = "animated-circle-1";
              var circlebar = new ProgressBar.Circle( document.getElementById(circclass1), {
                color: '#0a424a',
                trailColor: '#c9f5d9',
                strokeWidth: 8,
                duration: 1500,
              });

              var circclass2 = "animated-circle-2";
              var circlebar_2 = new ProgressBar.Circle( document.getElementById(circclass2), {
                color: '#0a424a',
                trailColor: '#c9f5d9',
                strokeWidth: 8,
                duration: 1500,
              });

              var circclass3 = "animated-circle-3";
              var circlebar_3 = new ProgressBar.Circle( document.getElementById(circclass3), {
                color: '#0a424a',
                trailColor: '#c9f5d9',
                strokeWidth: 8,
                duration: 1500,
              });

              circlebar.animate(1);
              circlebar_2.animate(1);
              circlebar_3.animate(1);
            }
          }
        });
      } else {
        if (isScrolledIntoView($elem)) {
          $elem.find('.animated-numbers-wrap').addClass('animated');
          $elem.find('.large-nr').each(function () {
            var options = {
                useEasing: false,
                useGrouping: true,
                separator: '',
                decimal: '',
                prefix: '',
                suffix: '',
            };
            var suffix = $(this).attr('data-suffix'),
                prefix = $(this).attr('data-prefix'),
                number = $(this).attr('data-number'),
                grouping = $(this).attr('data-grouping'),
                separator = $(this).attr('data-separator'),
                decimals = 0,
                decimal = $(this).attr('data-decimal');
            if (number.indexOf('.') !== -1) {
                decimals = 1;
            }
            if (grouping === "true") {
                options.useGrouping = true;
                options.decimal = decimal;
                options.separator = separator;
            } else {
                options.useGrouping = false;
            }
            if (prefix !== "false") {
                options.prefix = prefix;
            }
            if (suffix !== "false") {
                options.suffix = suffix;
            }
            var countup = new CountUp($(this)[0], number, decimals, options);
            var circclass1 = "animated-circle-1";
            var circlebar = new ProgressBar.Circle( document.getElementById(circclass1), {
              color: '#0a424a',
              trailColor: '#c9f5d9',
              strokeWidth: 10,
              duration: 1500,
            });

            var circclass2 = "animated-circle-2";
            var circlebar_2 = new ProgressBar.Circle( document.getElementById(circclass2), {
              color: '#0a424a',
              trailColor: '#c9f5d9',
              strokeWidth: 10,
              duration: 1500,
            });

            var circclass3 = "animated-circle-3";
            var circlebar_3 = new ProgressBar.Circle( document.getElementById(circclass3), {
              color: '#0a424a',
              trailColor: '#c9f5d9',
              strokeWidth: 10,
              duration: 1500,
            });

            countup.start();
            circlebar.animate(1);
            circlebar_2.animate(1);
            circlebar_3.animate(1);
          });
        }
      }
    }

    crw_animate_numbers();

    $(window).scroll(function () {
      crw_animate_numbers();
    });


    let img_width = $('#header-image-scroll').width();
    let window_width = $(window).width();
    let document_height = $(document).height() - $(window).height();

    $(function () {
        $(window).scroll(function () {
            var scroll_position = $(window).scrollTop();
            var object_position_left = window_width * (scroll_position / document_height);
            $('#header-image-scroll').css({
                'transform': "translateX( " + object_position_left + "px)",
            });
        });
    });

    const isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;

    $('.crw-accordion-image').each(function() {
      const $section = $(this);
      const sectionId = $section.attr('id');
      let tabCycle;
      const $tabs = $('#' + sectionId + ' .nav-tabs li');
      const $accordion = $('#' + sectionId + ' #accordion-' + sectionId);
      const $tabPanes = $('#' + sectionId + ' .tab-pane');

      $section.on('click', 'button.nav-link', function() {
        const $button = $(this);
        const $collapseTrigger = $button.next('a.invisible-trigger');
        const $listItem = $button.closest('li');

        $collapseTrigger.trigger('click');
        $tabs.removeClass('active');
        $listItem.addClass('active');
      });

      // Auto accordion on Desktop
      if (isMobile === false) {
        tabCycle = setInterval(function() {

          $accordion.each(function() {
            const $carousel = $(this);
            const $current = $carousel.find('.active');
            const $next = $current.next().length ? $current.next() : $carousel.children().eq(0);

            $next.addClass('active');
            $current.removeClass('active');

            const $activeButton = $next.find('button.nav-link');
            const $collapseTrigger = $activeButton.next('a.invisible-trigger');
            const $listItem = $activeButton.closest('li');
            const targetId = $activeButton.attr('data-target');
            const $targetPane = $(targetId);

            $listItem.addClass('active');
            $tabs.not($listItem).removeClass('active');
            $targetPane.addClass('show active');
            $tabPanes.not($targetPane).removeClass('show active');

            $targetPane.collapse('show');
            $tabPanes.not($targetPane).collapse('hide');

            // Collapse the previously active element
            const $prevCollapseTrigger = $current.find('a.invisible-trigger');
            const $prevCollapseTarget = $($prevCollapseTrigger.attr('href'));

            if ($prevCollapseTarget.length) {
              $prevCollapseTrigger.addClass('collapsed');
              $prevCollapseTarget.removeClass('show');
            }

            // Expand the new element
            const $collapseTarget = $($collapseTrigger.attr('href'));
            if ($collapseTarget.length) {
              $collapseTrigger.removeClass('collapsed');
              $collapseTarget.addClass('show');
            }

            //todo: need to replace with bootstrap collapse
          });
        }, 3000);

        // Stop cycling on user interaction
        $('#' + sectionId).on('click', 'button.nav-link', function(e) {
          e.preventDefault();
          clearInterval(tabCycle);
        });
      }
    });

    $(document).find("header.crw-main-header li.has-megamenu").on({
      mouseenter: function () {
        // $(this).children('.mega-sub-menu').addClass('show');

        if ( $(this).hasClass('has-megamenu') ) {
          $('body').addClass('crw-menu-open');
        }
      },
      mouseleave: function () {
        $('body').removeClass('crw-menu-open');
        if ( $(this).hasClass('has-megamenu') ) {
          $('body').removeClass('crw-menu-open');
        }
      },
    });

    $(document).on(
      "click",
      "header.mobile-menu .navbar-toggler",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("body").toggleClass("mm-menu-open");
        $("header.mobile-menu #crw-nav-icon").toggleClass("open");
      }
    );


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js